import { memo } from "react";

import { RadioInput } from "../../../../components/RadioInput";
import { classNames } from "../../../../utils/styles";
import { Container } from "./styles";

type SelectionProps = {
  title: string;
  /** Smaller line under the title (e.g. the Keepo's address). */
  subtitle?: string;
  /** Shown before the text (e.g. the Keepo's thumbnail or a "+" icon). */
  leading?: React.ReactNode;
  /** Dashed outline, for the "create a new one" choice. */
  dashed?: boolean;
  active: boolean;
  onClick: () => void;
  rightChildren?: React.ReactNode;
  tabIndex: number;
};

/** One choice of a single-choice list: a card with a radio on the right, green when selected. */
export const ItemSelection = memo(function ItemSelection({
  title,
  subtitle,
  leading,
  dashed,
  active,
  onClick,
  rightChildren,
  tabIndex,
}: SelectionProps) {
  return (
    <Container
      type="button"
      role="radio"
      aria-checked={active}
      tabIndex={tabIndex}
      className={classNames({ active, dashed })}
      onClick={onClick}>
      {leading && <span className="leading">{leading}</span>}
      <span className="text">
        <span className="title">{title}</span>
        {subtitle && <span className="subtitle">{subtitle}</span>}
      </span>
      {rightChildren}
      <RadioInput active={active} />
    </Container>
  );
});
